export default function GridRenderer(arg, showParams = false, extraRows = 8) {
  const level = Object.keys(arg).includes("grid") ? arg : null;
  const grid = level ? level.grid : arg;
  const {
    rows,
    columns,
    getTile,
    gridToLevel,
    getItem,
    tileSize
  } = grid;
  return (p, scene) => {
    p.clear();
    p.fill(0);
    p.noStroke();
    p.textAlign(p.CENTER, p.CENTER);
    const rowCount = rows + extraRows;
    for (let row = 0; row < rowCount; row++) {
      for (let col = 0; col < columns; col++) {
        const tile = getTile(col, row >= rows ? rows - 1 : row);
        const tilePos = gridToLevel({
          x: col,
          y: row
        });
        if (tile) {
          const {
            sprite
          } = tile;
          p.push();
          if (checkDisabled(level, tile)) p.tint(255, 64);
          p.image(sprite, tilePos.x, tilePos.y);
          p.pop();
          if (showParams) renderTileParams(p, tile, tilePos, tileSize);
        }
        if (row >= rowCount) continue;
        const item = getItem(col, row);
        if (item) {
          const {
            sprite
          } = item;
          p.image(sprite, tilePos.x, tilePos.y);
        }
      }
    }
  };
}
function checkDisabled(level, tile) {
  if (!level) return;
  const {
    params
  } = tile;
  if (!params || !("disableOn" in params)) return false;
  const [section, value] = params.disableOn.split(":");
  if (section != "item") return false;
  return Object.keys(level.player.items).includes(value);
}
function renderTileParams(p, tile, tilePos, tileSize) {
  const {
    params
  } = tile;
  if (params?.blocking) {
    p.noFill();
    p.strokeWeight(1);
    p.stroke([255, 0, 0, 64]);
    p.line(tilePos.x, tilePos.y, tilePos.x + tileSize, tilePos.y + tileSize);
    p.line(tilePos.x, tilePos.y + tileSize, tilePos.x + tileSize, tilePos.y);
  }
  if (params?.walkable) {
    p.noStroke();
    p.fill([255, 255, 0, 64]);
    p.rect(tilePos.x, tilePos.y, tileSize, 20);
  }
}